var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseSingletonService, Singleton } from '~/services/service.base';
export let ServiceConfig = class ServiceConfig extends BaseSingletonService {
    awsUrls = {
        'm-fonds-dev.linkavie.com': 'https://s3-eu-west-3.amazonaws.com/linkavieairitagedev/',
        'm-fonds-dev.airitage.fr': 'https://s3-eu-west-3.amazonaws.com/linkavieairitagedev/',
        'm-fonds.linkavie.com': 'https://s3-eu-west-3.amazonaws.com/linkavieairitageprod2/',
        'm-fonds.airitage.fr': 'https://s3-eu-west-3.amazonaws.com/linkavieairitageprod2/',
        'm-fonds2.linkavie.com': 'https://s3-eu-west-3.amazonaws.com/linkavieairitageprod2/',
        'm-fonds2.airitage.fr': 'https://s3-eu-west-3.amazonaws.com/linkavieairitageprod2/',
    };
    siteUrl = 'https://airitage.fr/';
    restorePasswordUrl = 'https://social.airitage.fr/#/fr/forgot-password';
    registerUserUrl = `${this.siteUrl}/devenir-adherent/`;
    mainPageRedirectUrl = this.siteUrl;
    awsUrl = this.awsUrls[location.host]
        ? this.awsUrls[location.host]
        : this.awsUrls['m-social.airitage.fr'];
    dateFormat = 'dd/MM/yyyy';
    lang = 'fr';
};
ServiceConfig = __decorate([
    Singleton()
], ServiceConfig);
